import { COUNTRY_CONFIG } from "../constants";
import { CountryCode, DropdownItem } from "../types";

export const getCountryConfig = (
  country?: string,
): {
  stateLabel: string;
  zipLabel: string;
  statesDropdown: DropdownItem[];
} => {
  const countryCode: CountryCode = country === "CA" ? "CA" : "US";

  return COUNTRY_CONFIG[countryCode];
};
